import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import Checkmark from "@/components/ui/checkmark";
import { Close } from "@dreamhub/designsystem/icons";
import { IconButton } from "@/components/ui/icon-button";

const TRANSLATION_KEY = "settings.deals.fieldConfiguration.checklistAppearance";

const ChecklistAppearancePreview: React.FC = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex flex-col gap-3">
      <Text
        onClick={() => setIsOpen((prev) => !prev)}
        className="cursor-pointer self-start pl-1 leading-5 font-normal transition-colors duration-200 text-link hover:text-link-hover"
      >
        {t(`${TRANSLATION_KEY}.toggleLink`)}
      </Text>

      {isOpen && (
        <div className="flex flex-col rounded-2xl border border-border-border1 bg-surface-droplist-popover shadow-tooltip">
          <div className="flex p-2 pl-4 items-center justify-between border-b border-border-border1">
            <Text variant="smSubtitle">{t(`${TRANSLATION_KEY}.title`)}</Text>
            <IconButton
              size="md"
              onClick={() => setIsOpen(false)}
              variant="iconNoBg"
              iconColor="secondary"
            >
              <Close />
            </IconButton>
          </div>
          <div className="flex flex-col p-4 gap-4">
            <div className="flex flex-col">
              <Text
                variant="smBodySecondary"
                className="pt-2 pl-2 pr-3 pb-[2px]"
              >
                {t(`${TRANSLATION_KEY}.unmarked`)}
              </Text>
              <div className="pointer-events-none py-2 pl-[2px] pr-3">
                <Checkmark
                  checked={false}
                  label={t(`${TRANSLATION_KEY}.fieldNamePlaceholder`)}
                />
              </div>
            </div>
            <div className="flex flex-col">
              <Text
                variant="smBodySecondary"
                className="pt-2 pl-2 pr-3 pb-[2px]"
              >
                {t(`${TRANSLATION_KEY}.markedCompleted`)}
              </Text>
              <div className="pointer-events-none py-2 pl-[2px] pr-3">
                <Checkmark
                  checked={true}
                  label={t(`${TRANSLATION_KEY}.fieldNamePlaceholder`)}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChecklistAppearancePreview;
